import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { ID8_GEN_TYPES } from '../../../constants';
import useProjectStatusTracker from '../../../hooks/useProjectStatusTracker';
import { getId8FormData, getMessagesByTab } from '../../../redux/id8/id8Actions';
import { changeActiveGenStatus } from '../../../redux/id8/id8Reducer';
import { clearNotificationStatus, setNotificationStatus } from '../../../redux/notifier/notifierReducer';
import useIsMessagesGenerating from '../../hooks/useIsMessagesGenerating';

function MessagesGeneratingStatusController() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const isGenerating = useIsMessagesGenerating();

  const handleSetGeneratingStatus = (status) => {
    dispatch(changeActiveGenStatus({ genType: ID8_GEN_TYPES.IDEAS, status }));
  };

  const handleUpdateForm = () => {
    dispatch(getId8FormData({ id }));
    dispatch(getMessagesByTab());
  };

  useProjectStatusTracker({
    onChangeStatus: handleSetGeneratingStatus,
    onInitialUpdate: handleUpdateForm,
  });

  useEffect(() => {
    if (isGenerating) {
      dispatch(setNotificationStatus('messagesGenerationInProgress'));
    } else {
      dispatch(clearNotificationStatus());
    }
  }, [isGenerating, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [dispatch]);

  return null;
}

export default MessagesGeneratingStatusController;
